/* eslint-disable */
/*
 * @Author: qiangmin
 * @Date: 2021-05-10 17:56:12
 * @LastEditTime: 2021-05-10 14:21:28
 * @LastEditors: qiangmin
 * @Description: In User Settings Edit
 * @FilePath: \zz-platform-pages\src\skeleton\index.js
 */

const hashParse = location.href.split('#')
const hashRoute = hashParse && hashParse[1]
const skeletons = [
  {
    route: /\/WinterHoliday2021\/Home/,
    component: () => import(/* webpackPrefetch: true */ './index.css'),
  }
]

if (hashRoute) {
  for (let i = 0; i < skeletons.length; i++) {
    if (skeletons[i].route.test(hashRoute)) {
      skeletons[i].component()
      break
    }
  }
}
